import styles from '@styles/components/you-may-also-like-honey-list/index.module.scss';
import Link from "next/link";
import * as React from "react";

export const YouMayAlsoLikeHoneyList = ({title = '', productType: string ='', honeyList = []}) => {
    return (<>
        {
            honeyList && honeyList.length != 0 &&
            <section className={styles.container}>
                <h3>{title}</h3>
                <hr/>
                <div className={`product_list`}>
                    {
                        honeyList.map((item: any, index: number) => {
                            return (<div key={'product-' + index}
                                         className={`item item_honey`}>
                                <Link href={`/products/detail/${item.attributes.Collection.data.attributes.Link}/`+ item.attributes.Shopify_Link}>
                                    <img loading={"lazy"}
                                         className={`img_honey`}
                                         src={item.attributes.Image.data.attributes.url}
                                         alt={item.attributes.Image.data.attributes.alternativeText}/>
                                    <div
                                        className={`bar_line bar_line_honey`}></div>
                                    <p>{item.attributes.Title}</p>
                                </Link>
                            </div>)
                        })
                    }
                </div>
                <hr/>
            </section>
        }

    </>)
}
